import * as index from '@syncfusion/ej2-maps';
index.Maps.Inject( index.Bubble,index.Legend,index.Marker,index.Highlight,index.Selection,index.MapsTooltip,index.Zoom,index.DataLabel,index.NavigationLine,index.Annotations,index.Print,index.PdfExport,index.ImageExport);
export * from '@syncfusion/ej2-maps';
